import { Sun } from "lucide-react";

export const Logo = ({ dark = false }) => (
  <span translate="no" className="flex items-center gap-2">
    <span className="grid h-8 w-8 place-items-center rounded-lg bg-emerald-500 text-slate-900">
      <Sun className="h-5 w-5" strokeWidth={2.2} />
    </span>
    <span className={`font-display text-lg font-semibold tracking-tight ${dark ? "text-white" : "text-slate-900"}`}>
      Apollo<span className="text-emerald-500"> Solar</span>
    </span>
  </span>
);
